import { Fragment, useEffect, useRef, useState } from "react";

import { ReactComponent as GalileIcon } from "../../../../public/logos/galilea-icono.svg";
import AnimationComponent from "../../../../components/new_components/animation";
import finishSound from "./../../../../public/sounds/nave_aterrizando.mp3";
import { HttpRequest } from "../../../../services/httpRequest";
import { pasoRenovacion, trackEvent } from "../../../../services/analytics/track";
import { creditOfferStore } from "../../../../store/creditStore/offerCreditStore";
import { InfoAlert } from "../../../../components/alerts/infoAlert";
import { ErrorAlert } from "../../../../components/alerts/errorAlert";
import { AgreeLocations } from "../../../../components/new_components/agreeLocations";
import { AlertProvider } from "../bankFlowSelector/provider/alertProvider";
import { CreditStatusEnum } from "../../../../constants/CreditStatusEnum";
import RenovarBienvenidoPage from "./RenovarBienvenidoPage";
import { stepsCreditStore } from "../../../../store/creditStore/stepsCreditStore";
import RenovarDatosOfertaForm from "./RenovarDatosOfertaForm";
import UpdateDatosBancariosForm from "./UpdateDatosBancariosForm";
import { RenovarProgressBarComponent } from "./components/RenovarProgressBar";
import RenovarDatosOtp from "./RenovarDatosOtp";

export function RenovarCreditoPage() {
  const [messsageAlert] = useState("");
  const [alertSession] = useState(false);
  const [isOpenError] = useState(false);
  const [isOpenInfo] = useState(false);
  const [openModalLocation, setOpenModalLocation] = useState(false);
  const [isFinishPass, setIsFinishPass] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [currentStep, setCurrentStep] = useState(null);
  const [totalSteps] = useState(4);

  const url_string = window.location.href;
  const url = new URL(url_string);
  const transferCode = url.searchParams.get("transferCode");
  const transferState = url.searchParams.get("transferState");
  const audioRef = useRef(null);
  const starsRef = useRef(null);

  useEffect(() => {
    const newUrl =
      window.location.origin + window.location.pathname + window.location.hash;
    window.history.replaceState({}, document.title, newUrl);
  }, []);

  const stepTitles = [
    "Revisemos la oferta.",
    // "Revisa las condiciones de tu crédito.",
    "Conecta tu banco.",
    "Firmar Documentos.",
  ];

  const handleStepChange = (nextStep) => {
    // Evitar llamadas redundantes
    if (nextStep === currentStep) return;
    if (nextStep > currentStep) trackEvent("solicitud_paso_completado", pasoRenovacion(currentStep));

    // Paso final (bienvenida)
    if (nextStep === 4) {
      setIsFinishPass(true);

      stepsCreditStore.getState().saveSteps({
        stepInternal: 1,
        stepGeneral: nextStep,
        loading: false,
      });

      setCurrentStep(nextStep);

      setTimeout(() => {
        setIsFinishPass(false);
      }, 11000);

      return;
    }

    stepsCreditStore.getState().saveSteps({
      stepInternal: 1,
      stepGeneral: nextStep,
      loading: false,
    });

    setCurrentStep(nextStep);
  };

  useEffect(() => {
    if (!audioRef.current) return;

    let timeoutId;
    const audio = audioRef.current;

    if (isFinishPass) {
      setTimeout(() => {
        audio.pause();
        audio.volume = 0.5;
        audio.muted = false;

        const playPromise = audio.play();
        if (playPromise) {
          playPromise.catch((err) => console.warn("Autoplay bloqueado:", err));
        }

        timeoutId = setTimeout(() => {
          audio.pause();
          audio.currentTime = 0;
          audio.volume = 0;
        }, 4300);
      }, 5000);
    }

    return () => clearTimeout(timeoutId);
  }, [isFinishPass]);

  useEffect(() => {
    const unsubscribe = stepsCreditStore.subscribe((state) => {
      const stepCredit = state.stepCredit;
      if (stepCredit && stepCredit.loading) {
        setCurrentStep(stepCredit.stepGeneral);
      }
    });
    return unsubscribe;
  }, []);

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkIfMobile();
    window.addEventListener("resize", checkIfMobile);

    return () => window.removeEventListener("resize", checkIfMobile);
  }, []);

  useEffect(() => {
    if (transferCode !== null && transferCode !== undefined) {
      localStorage.setItem("transferCode", transferCode);
      localStorage.removeItem("transferState");
    }

    if (transferState !== null && transferState !== undefined) {
      localStorage.setItem("transferState", transferState);
    }
  }, [transferState, transferCode]);

  useEffect(() => {
    const loadInitialData = async () => {
      await Promise.all([
        stepsCreditStore.getState().loadSteps(),
        creditOfferStore.getState().loadOfertCredit(),
      ]);
    };

    loadInitialData();
  }, []);

  useEffect(() => {
    const loadCreditUserPendingSignature = async () => {
      try {
        const data = await HttpRequest.getCreditUserPendingSignature(
          localStorage.getItem("doc"),
        );
        const credit = data.message.info;
        if (credit.status === CreditStatusEnum.PF) {
          stepsCreditStore.getState().saveSteps({
            stepInternal: 1,
            stepGeneral: 1,
            loading: true,
          });

          creditOfferStore.getState().saveOfertCredit({
            ...credit,
            selectedQuota: credit.approvedQuota,
          });
          localStorage.setItem("credit_aprobate", true);
          return;
        }
        return credit;
      } catch (error) {
        console.log(error);
      }
    };
    loadCreditUserPendingSignature();
  }, []);

  useEffect(() => {
    const canvas = starsRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    let W = 0;
    let H = 0;
    let stars = [];
    let animationId;

    const resize = () => {
      W = canvas.width = window.innerWidth;
      H = canvas.height = window.innerHeight;
    };

    const createStar = () => ({
      x: Math.random() * W,
      y: Math.random() * H,
      r: Math.random() * 1 + 0.2,
      a: Math.random(),
      da: (Math.random() * 0.005 + 0.001) * (Math.random() < 0.5 ? 1 : -1),
    });

    const init = () => {
      resize();
      stars = Array.from({ length: 160 }, createStar);
    };

    const draw = () => {
      ctx.clearRect(0, 0, W, H);

      for (const star of stars) {
        star.a += star.da;

        if (star.a <= 0.04 || star.a >= 1) {
          star.da *= -1;
        }

        ctx.beginPath();
        ctx.arc(star.x, star.y, star.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(255,255,255,${star.a.toFixed(2)})`;
        ctx.fill();
      }

      animationId = requestAnimationFrame(draw);
    };

    window.addEventListener("resize", resize);

    init();
    draw();

    return () => {
      window.removeEventListener("resize", resize);
      cancelAnimationFrame(animationId);
    };
  }, []);

  const AudioPlayer = () => (
    <audio ref={audioRef} src={finishSound} preload="auto" />
  );

  const getContainerStyle = () => {
    if (currentStep === 4) {
      return {
        width: isMobile ? "90vw" : "max(600px, 40vw)",
        height: isMobile ? "auto" : "max(690px, 66vh)",
        minHeight: isMobile ? "70vh" : "500px",
        maxHeight: "95vh",
        position: "fixed", // Fixed es mejor para centrado
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        borderRadius: isMobile ? "20px" : "30px",
        padding: isMobile ? "24px" : "40px",
        margin: 0,
        overflow: "auto",
        boxSizing: "border-box",
        zIndex: 100,
      };
    }

    return {
      width: "-webkit-fill-available",
      height: "-webkit-fill-available",
      backgroundColor: "#29214F",
      left: isMobile ? "20px" : "390px",
      top: "clamp(150px, 6vw, 200px)",
      position: "absolute",
      borderRadius: "30px",
      marginRight: isMobile ? "20px" : "107px",
      marginBottom: "clamp(50px, 3vw, 80px)",
    };
  };

  return (
    <AlertProvider>
      <Fragment>
        {openModalLocation && (
          <>
            <AgreeLocations
              isOpen={openModalLocation}
              onOpenChange={setOpenModalLocation}
            />
          </>
        )}
        {alertSession && (
          <>
            <InfoAlert
              isOpen={isOpenInfo}
              message={messsageAlert}
              isDesktop={true}
            ></InfoAlert>
            <ErrorAlert
              isOpen={isOpenError}
              message={messsageAlert}
            ></ErrorAlert>
          </>
        )}
        <AudioPlayer />

        {isFinishPass ? (
          <>
            <Fragment>
              <div
                className="fixed inset-0 flex items-center justify-center min-h-screen w-full z-50"
                style={{
                  backgroundColor: "#000000",
                  color: "white",
                  overflow: "hidden",
                }}
              >
                <canvas
                  ref={starsRef}
                  className="fixed inset-0 w-full h-full pointer-events-none"
                ></canvas>
                {!isMobile && (
                  <div
                    style={{
                      backgroundColor: "#29214F",
                      borderTopRightRadius: "50px",
                      borderBottomRightRadius: "50px",
                      width: "187px",
                      height: "62px",
                      position: "absolute",
                      left: 0,
                      top: 40,
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                      padding: "6px 20px 6px 0px",
                    }}
                  >
                    <GalileIcon
                      alt="Galilea"
                    // style={{
                    //   cursor: "pointer",
                    // }}
                    /* onClick={() => {
                    cleanIndexDB();
                    navigate("/");
                  }} */
                    />
                  </div>
                )}

                {!isMobile && (
                  <div
                    class="z-20 flex flex-col md:flex-row items-center justify-center gap-2.5 text-[#ffffff]/70 pointer-events-none select-none tracking-widest uppercase font-light text-[10px] text-center my-6 md:my-0 md:fixed md:w-auto md:left-[-290px] md:top-[50%] md:-translate-y-1/2 md:-rotate-90 md:origin-center">
                    <div class="flex flex-row items-center justify-center gap-4 mr-2">
                      <div class="flex items-center md:border-r border-[#ffffff]/30 pr-4 shrink-0 capitalize">
                        <img src="https://galilea.co/png/colombia-fintech.png" class="h-8 w-auto object-contain"
                          alt="colombia fintech" />
                      </div>

                      <div class="flex items-center md:border-r border-[#ffffff]/30 md:pr-4 shrink-0">
                        <img src="https://galilea.co/png/sic.png" class="h-6 w-auto object-contain brightness-0 invert opacity-90"
                          alt="Superintendencia de Industria y Comercio" />
                      </div>
                    </div>
                    <span
                      class="normal-case text-[11px] leading-tight tracking-normal text-[#ffffff]/70 max-w-[280px] md:max-w-[340px] font-semibold2">
                      Galilea es una marca de GRUPO EMPRESARIAL ANAV S.A.S GEAA <br class="hidden md:inline" />registrada en
                      Colombia con NIT: 901.582.748-5
                    </span>

                  </div>
                )}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "-webkit-fill-available",
                  }}
                >
                  <AnimationComponent
                    animationUrl="/animations/galileaAterrizaje.riv"
                    width={
                      isMobile
                        ? "clamp(27rem, 25vw, 30rem)"
                        : "clamp(15rem, 40vw, 60rem)"
                    }
                    height={
                      isMobile
                        ? "clamp(34rem, 25vh, 30rem)"
                        : "clamp(25rem, 80vh, 76rem)"
                    }
                    heightContainer={
                      isMobile ? "35rem" : "clamp(25rem, 80vh, 76rem)"
                    }
                    isDesktop={!isMobile}
                    stateMachines={["rocketLanding"]}
                    artboard={"rocketLanding"}
                    animations={["rocketLanding"]}
                    pointerEvents={"none"}
                  />
                </div>
              </div>
            </Fragment>
          </>
        ) : (
          <>
            <Fragment>
              {isMobile ? (
                <div
                  className="flex flex-col relative w-full"
                  style={{
                    backgroundColor: "#000000",

                    backgroundSize: currentStep === 4 && "cover",
                    backgroundRepeat: currentStep === 4 && "no-repeat",
                    color: "white",
                    height: "100dvh",
                    overflow: "hidden",
                  }}
                >
                  <canvas
                    ref={starsRef}
                    className="fixed inset-0 w-full h-full pointer-events-none"
                  ></canvas>
                  <div
                    className="flex md:hidden sticky top-0"
                    style={{
                      margin: "16px",
                      paddingLeft: "30px",
                    }}
                  >
                    {currentStep !== 4 && (
                      <RenovarProgressBarComponent
                        iconStart={
                          <AnimationComponent
                            animationUrl="/animations/nave_galilea.riv"
                            rotateValue={"90deg"}
                            width={"3.5rem"}
                            height={"3.5rem"}
                            heightContainer={"3.5rem"}
                            isDesktop={isMobile}
                          />
                        }
                        iconEnd={
                          <AnimationComponent
                            animationUrl="/animations/planeta_galilea.riv"
                            width={"3.5rem"}
                            height={"3.5rem"}
                            isDesktop={isMobile}
                          />
                        }
                        totalSteps={totalSteps}
                        currentStep={currentStep}
                        stepTitles={stepTitles}
                        hiddenIconStart={true}
                      />
                    )}
                  </div>

                  <div
                    className="flex-1 overflow-y-auto relative z-1"
                    style={{
                      overflowX: "hidden",
                    }}
                  >
                    {currentStep === 1 && (
                      <RenovarDatosOfertaForm
                        onStepChange={handleStepChange}
                        currentStep={currentStep}
                        currentStepGeneral={currentStep}
                        stepTitlesGeneral={stepTitles}
                        isDesktop={false}
                      />
                    )}
                    {currentStep === 2 && (
                      <UpdateDatosBancariosForm
                        onStepChange={handleStepChange}
                        currentStep={currentStep}
                        currentStepGeneral={currentStep}
                        stepTitlesGeneral={stepTitles}
                      />
                    )}
                    {currentStep === 3 && (
                      <RenovarDatosOtp
                        onStepChange={handleStepChange}
                        currentStep={currentStep}
                        currentStepGeneral={currentStep}
                        stepTitlesGeneral={stepTitles}
                      />
                    )}
                    {currentStep === 4 && (
                      <RenovarBienvenidoPage
                        onStepChange={handleStepChange}
                        currentStep={currentStep}
                        currentStepGeneral={currentStep}
                        stepTitlesGeneral={stepTitles}
                      />
                    )}
                  </div>
                </div>
              ) : (
                <div
                  className="min-h-screen flex flex-col relative w-full"
                  style={{
                    backgroundColor: "#000000",
                    color: "white",
                    overflow: "hidden",
                    backgroundSize:
                      currentStep === 4 && (!isMobile ? "100%" : "150%"),
                    backgroundRepeat: currentStep === 4 && "no-repeat",
                  }}
                >
                  <canvas
                    ref={starsRef}
                    className="fixed inset-0 w-full h-full pointer-events-none"
                  ></canvas>
                  <div
                    style={{
                      backgroundColor: "#29214F",
                      borderTopRightRadius: "50px",
                      borderBottomRightRadius: "50px",
                      width: "187px",
                      height: "62px",
                      position: "absolute",
                      left: 0,
                      top: 40,
                      display: "flex",
                      justifyContent: "flex-end",
                      padding: "6px 20px 6px  0px",
                    }}
                  >
                    <GalileIcon
                      alt="Galilea"
                    // style={{
                    //   cursor: "pointer",
                    // }}
                    /* onClick={() => {
                    cleanIndexDB();
                    navigate("/");
                  }} */
                    />
                  </div>

                  <div
                    class="z-20 flex flex-col md:flex-row items-center justify-center gap-2.5 text-[#ffffff]/70 pointer-events-none select-none tracking-widest uppercase font-light text-[10px] text-center my-6 md:my-0 md:fixed md:w-auto md:left-[-290px] md:top-[50%] md:-translate-y-1/2 md:-rotate-90 md:origin-center">
                    <div class="flex flex-row items-center justify-center gap-4 mr-2">
                      <div class="flex items-center md:border-r border-[#ffffff]/30 pr-4 shrink-0 capitalize">
                        <img src="https://galilea.co/png/colombia-fintech.png" class="h-8 w-auto object-contain"
                          alt="colombia fintech" />
                      </div>

                      <div class="flex items-center md:border-r border-[#ffffff]/30 md:pr-4 shrink-0">
                        <img src="https://galilea.co/png/sic.png" class="h-6 w-auto object-contain brightness-0 invert opacity-90"
                          alt="Superintendencia de Industria y Comercio" />
                      </div>
                    </div>
                    <span
                      class="normal-case text-[11px] leading-tight tracking-normal text-[#ffffff]/70 max-w-[280px] md:max-w-[340px] font-semibold2">
                      Galilea es una marca de GRUPO EMPRESARIAL ANAV S.A.S GEAA <br class="hidden md:inline" />registrada en
                      Colombia con NIT: 901.582.748-5
                    </span>

                  </div>
                  {currentStep !== 4 && (
                    <RenovarProgressBarComponent
                      iconStart={
                        <AnimationComponent
                          animationUrl="/animations/nave_galilea.riv"
                          rotateValue={"90deg"}
                          width={"clamp(5rem, 4vw, 20rem)"}
                          height={"clamp(5rem, 4vw, 20rem)"}
                          isDesktop={!isMobile}
                        />
                      }
                      iconEnd={
                        <AnimationComponent
                          animationUrl="/animations/planeta_galilea.riv"
                          width={"clamp(2.5rem,5vw,4.5rem)"}
                          height={"clamp(2.5rem,5vw,4.5rem)"}
                          isDesktop={!isMobile}
                        />
                      }
                      totalSteps={totalSteps}
                      currentStep={currentStep}
                      isDesktop={true}
                      stepTitles={stepTitles}
                      hiddenIconStart={true}
                    />
                  )}
                  {currentStep !== 4 && (
                    <div
                      style={{
                        position: "absolute",
                        top: "clamp(80px, 6vw, 30px)",
                        left: "400px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                      }}
                    >
                      <div style={{ fontSize: "14px", color: "#BEBCC2" }}>
                        <div
                          className="text-sm mb-1.5"
                          style={{ color: "#c8cbda" }}
                        >
                          Paso {currentStep} de {stepTitles.length}
                        </div>
                      </div>
                      <div className="font-bold2" style={{ fontSize: "18px" }}>
                        {stepTitles && stepTitles[currentStep - 1]}
                      </div>
                    </div>
                  )}
                  <div style={getContainerStyle()}>
                    <div
                      className="flex-1 overflow-y-auto relative z-10"
                      style={{
                        overflowX: "hidden",
                        height: "-webkit-fill-available",
                        width: "-webkit-fill-available",
                        scrollbarWidth: "none",
                      }}
                    >
                      {currentStep === 1 && (
                        <RenovarDatosOfertaForm
                          onStepChange={handleStepChange}
                          currentStep={currentStep}
                          currentStepGeneral={currentStep}
                          stepTitlesGeneral={stepTitles}
                          isDesktop={true}
                        />
                      )}
                      {currentStep === 2 && (
                        <UpdateDatosBancariosForm
                          onStepChange={handleStepChange}
                          currentStep={currentStep}
                          currentStepGeneral={currentStep}
                          stepTitlesGeneral={stepTitles}
                          isDesktop={true}
                        />
                      )}
                      {currentStep === 3 && (
                        <RenovarDatosOtp
                          onStepChange={handleStepChange}
                          currentStep={currentStep}
                          currentStepGeneral={currentStep}
                          stepTitlesGeneral={stepTitles}
                          isDesktop={true}
                        />
                      )}
                      {currentStep === 4 && (
                        <RenovarBienvenidoPage
                          onStepChange={handleStepChange}
                          currentStep={currentStep}
                          currentStepGeneral={currentStep}
                          stepTitlesGeneral={stepTitles}
                          isDesktop={true}
                        />
                      )}
                    </div>
                  </div>
                  {/* <FloatingWhatsApp
                  show={currentStep !== 4}
                  phone="3124008320"
                  message={`Hola, estoy en el paso ${currentStep} de mi solicitud y necesito soporte.`}
                /> */}
                </div>
              )}

              <style>
                {`
              .degraded-border {
                position: fixed;
                right: 0;
                bottom: 0;
                height: 80vh;
                background-color: transparent;
                border-top-left-radius: 150px;
                border-left: 0.1px solid #575684;
                overflow: hidden;
              }
              .degraded-border2 {
                position: fixed;
                width: 80vh;
                background-color: transparent;
                border-top-left-radius: 150px;
                border-top: 0.1px solid #575684;
                overflow: hidden;
              }

              .degraded-border2::before {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                height: 1.6px;
                width: 100%;
                background:linear-gradient(90deg, #575684 50.30%, #14141E 80.30%, transparent 14.40%);
              }

              .degraded-border::after {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                width: 1.6px;
                height: 100%;
                background: linear-gradient(190deg, #575684 70.70%, #786E9900 70.30%);
              }
            `}
              </style>
            </Fragment>
          </>
        )}
      </Fragment>
    </AlertProvider>
  );
}
